/**
 * postPoll.api.ts — poll voting for news posts.
 * Backend: EpPostPollService.js
 */
import apiClient from './client';
import type { PollVote } from './types';

const PostPollAPI = {
  /** Get all votes for a post */
  async getResults(postId: string): Promise<PollVote[]> {
    const { data } = await apiClient.get(`/v3/post-polls/${postId}/results`);
    return (data as any)?.result ?? data ?? [];
  },

  /** Submit a vote */
  async vote(postId: string, payload: {
    userId: string;
    userName?: string;
    optionId: string;
  }): Promise<PollVote> {
    const { data } = await apiClient.post(`/v3/post-polls/${postId}/vote`, payload);
    return (data as any)?.result ?? data;
  },

  /** Retract own vote */
  async retractVote(postId: string, userId: string): Promise<void> {
    await apiClient.delete(`/v3/post-polls/${postId}/vote`, { data: { userId } });
  },
};

export default PostPollAPI;
